import { Table as AntdTable } from "antd";
import { TableProps as AntdTableProps } from "antd/lib/table";
import React from "react";

export type MyTableProps<RecordType = any> = AntdTableProps<RecordType>;

export interface TableStaticMethods {
  Column: typeof AntdTable.Column;
  ColumnGroup: typeof AntdTable.ColumnGroup;
}

const TablePolyfill = <RecordType extends any = any>(
  props: MyTableProps<RecordType>,
) => {
  return <AntdTable {...props} />;
};

const TypedTable = TablePolyfill as typeof TablePolyfill & TableStaticMethods;

TypedTable.Column = AntdTable.Column;
TypedTable.ColumnGroup = AntdTable.ColumnGroup;

export default TypedTable;
